module.exports = "/images/vendor/svg-country-flags/svg/pt.svg?8de166591d0cbb7c34334e764259b617";